/**
 * ThresholdSettings — collapsible alert threshold sliders.
 */
import React, { useState } from 'react';

const THRESHOLD_DEFS = [
  { key: 'openTicketsAlert', label: 'Simultaneous Open Tickets Alert', unit: 'tickets',    min: 1,   max: 30,  step: 1   },
  { key: 'openIn20MinAlert', label: 'Tickets Opened in 20-Min Alert',  unit: 'tickets',    min: 1,   max: 30,  step: 1   },
  { key: 'staleMinutes',     label: 'Stale Ticket Threshold',          unit: 'min',         min: 5,   max: 60,  step: 5   },
  { key: 'revPaceLow',       label: 'Revenue Pace Low Alert',          unit: '× expected',  min: 0.2, max: 0.9, step: 0.1 },
  { key: 'revPaceHigh',      label: 'Revenue Pace High Alert',         unit: '× expected',  min: 1.1, max: 2.0, step: 0.1 },
];

export default function ThresholdSettings({ thresholds, setThresholds }) {
  const [show, setShow] = useState(false);
  return (
    <div className="ai__section">
      <button className="ai__thresh-toggle" onClick={() => setShow(v => !v)}>
        ⚙️ Alert Thresholds {show ? '▴' : '▾'}
      </button>
      {show && (
        <div className="ai__thresh-grid">
          {THRESHOLD_DEFS.map(({ key, label, unit, min, max, step }) => (
            <div key={key} className="ai__thresh-row">
              <label className="ai__thresh-label">{label}</label>
              <div className="ai__thresh-control">
                <input
                  type="range" min={min} max={max} step={step}
                  value={thresholds[key]}
                  onChange={e => setThresholds(t => ({ ...t, [key]: parseFloat(e.target.value) }))}
                  className="ai__thresh-slider"
                />
                <span className="ai__thresh-val">{thresholds[key]} {unit}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
